{{ 'questions.type.' + questionType | translate }}
<a href="#" (click)="openChangeTypeModal()">{{ text }}</a>
